import { CreationStatus } from '../../types/CreationStatus'

export const creationStatusMapper = {
	PENDING: 'Pendente',
	SUCCESS: 'Sucesso ao criar',
	FAIL: 'Falha ao criar'
} as Record<CreationStatus, string>
